export default "__VITE_ASSET__BaODmHn6__"